module.exports = __webpack_public_path__ + "img/drumkit.26b474fe.jpg";